import slice from './workspaceSlice';

export * from './workspaceSlice';

export default slice;
